"use client";

import React from 'react';

import { IntegrationShowcase, Integration } from '@/components/ui/integration-showcase';

// Tools we vibe with - AI-powered development stack
const integrationsData: Integration[] = [
    {
        name: 'Lovable',
        description: 'AI-powered web dev platform generates production-ready code.',
        iconSrc: '/assets/tools/lovable.png',
    },
    {
        name: 'Cursor',
        description: 'AI-first code editor builds faster with pair programming.',
        iconSrc: '/assets/tools/cursor.jpeg',
    },
    {
        name: 'v0',
        description: 'Vercel\'s AI UI generator creates beautiful React components.',
        iconSrc: '/assets/tools/v0.png',
    },
    {
        name: 'Replit',
        description: 'Cloud dev environment with AI code deploy scale.',
        iconSrc: '/assets/tools/replit.png',
    },
    {
        name: 'Bolt',
        description: 'AI dev tool accelerates full-stack application building.',
        iconSrc: '/assets/tools/bolt.jpeg',
    },
    {
        name: 'OpenAI',
        description: 'Powerful AI models for intelligent features and chatbots.',
        iconSrc: '/assets/tools/openai.png',
    },
    {
        name: 'Claude',
        description: 'Anthropic\'s AI assistant for code generation and analysis.',
        iconSrc: '/assets/tools/claude.png',
    },
    {
        name: 'Notion',
        description: 'All-in-one workspace for docs and project management.',
        iconSrc: '/assets/tools/notion.png',
    },
    {
        name: 'Vercel',
        description: 'Frontend cloud platform deploys high-performance web apps.',
        iconSrc: '/assets/tools/vercel.png',
    },
    {
        name: 'Airtable',
        description: 'Send submissions to Airtable databases and workflows.',
        iconSrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAjVBMVEVHcEz+uwD9tQDtnB/9tQD9tAD8tAD/tAD+tQD+tQD+tgD9tQD9tAD9tgDfJ1a8IEi6EEv/uAD9tAD9tQAOwP8Xv/8YwP/5K2DnJ1m5H0e6IEe8HUnxJ2AXwP8Wv/8Yv/8Yv/8YwP/5K2DDIUv9tQANx/8OwP8YwP8Uwv8UwP/WJFK9IEnAIEj5LGD5K2Cg/8aNAAAAL3RSTlMAJmwOVdb/HoR9NKfqiK7GUke6t1XEueL//+yMLzOT9v/h//+5D1zdJpr/mkSwqkV1VRMAAADASURBVHgBvc5FFgJBEATRxN3G3d3ufzxacGqWENv/SvCHJtPphJbZfLFkLeazL1qtBQnerN5ou1u+tdveZTbdL7/aTyVul2QTqZPD/mtwvRJ0PJ2Bi/JK6gXQdIOhadmO62G2WdyfncEPwiiKOSZWattiPNvv2VBe6BGvFJgkTNn4DKyqZkNvmDQ2r0VeSnhDoacOfkRhYjEC/JDC3gNGcGBEoyACYwAeIxINiAgM6wojqBc5QGIY+CCrQkPDr7sCTOYgaxntCWQAAAAASUVORK5CYII=',
    },
    {
        name: 'Make',
        description: 'Send submissions to your favorite tools automatically.',
        iconSrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAwFBMVEX//////f/RY/LKYvDy4PvZwPF3ANGPTNeqhN/n3PVqAMuLS9X33/3GAO++GuyxAOnId/DFoOqEFtV+INLMteuDPdPhYPfNDvHEIu7UkvOsbOOJINeEJ9Tt4/jbAPXXF/SSGduTKdvxW/vnDvnbivT49PyQANuZW9v/2//yAPzpzPmHGNe6keb/Vf/mhvjNmu//AP+5ZumnJeWDANfzhPz/0//37f2jAOSnVeL/g//lxPfCjev/Sf+3TurZuPKIMda9K89qAAAAt0lEQVR4Ad3QAQfCYBDG8f9tu7e3WVRUBUCRCFDfH4gAAhkgCKWoNmZZTcy26QvswXF+nsPR3sifxRFJVfKAvAC8wgL5JfYj8Gvoi0R+jt2ouFUUrUXOxmBPaQPHSjaam++AXMtnl5KAaEpfoN5UyCahJnBs4NLtGI1xhtgp6yCtoAKDEIHrSWrNjQsdh62STYFZBT2gu8eDoQsP1mXcacAF7kafLvTsYVX97XYPgPfOWAy4hbQrHxHNJ3cZ8ThjAAAAAElFTkSuQmCC',
    },
    {
        name: 'Zapier',
        description: 'Send submissions to your favorite tools seamlessly.',
        iconSrc: 'https://cdn.worldvectorlogo.com/logos/zapier.svg',
    },
    // {
    //     name: 'And many more',
    //     description: 'Integrate with thousands of tools via Zapier Make etc.',
    //     iconSrc: 'https://img.icons8.com/ios-glyphs/60/plus-math.png',
    // },
];

export const IntegrationShowcaseSection = () => {
    return (
        <section id="integrations" className="relative  overflow-hidden bg-background">
            <IntegrationShowcase
                title="Building with your ~favorite~ stack"
                subtitle="We use your favorite tools like Lovable, Cursor, Replit, v0 but with our secret sauce and expertise to create something for you that you can manage on your own but something that doesn't look vibe coded."
                illustrationSrc="https://images.unsplash.com/photo-1551650975-87deedd944c3?q=80&w=800"
                illustrationAlt="Integration tools and connections"
                integrations={integrationsData}
            />
        </section>
    );
};
